import React, { useContext, useEffect } from "react";
import { AuthContext } from "@context/AuthContext";
import Spinner from "@components/Ui/Spinner";

const AutoLogin = ({ children }) => {

    const { isLoggedIn, loginByToken } = useContext(AuthContext);

    useEffect(() => {
        if (isLoggedIn === null) {
            loginByToken();
        }
    }, [isLoggedIn]);


    return (
        <>
            {isLoggedIn === null ? (
                <Spinner text="loading..." center={true} />
            ) : (
                children
            )}
        </>
    );
};

export default AutoLogin;
